export { default as GTMInitializer } from './GTMInitializer';
